module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "wrap-black"
  }, [_vm._c('div', {
    staticClass: "container"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 signup-content xs-mb-50 md-mb-50"
  }, [_vm._c('h1', [_vm._v("Sign Up")]), _vm._v(" "), _vm._c('p', [_vm._v("\n          CLEX is aware that the cost of post secondary education is very expensive, and in order to make your life as stress free as possible,\n          we are giving you CLEX for free at no charge, with no obligation to purchase for as long as you need it. No three month trial like most service providers.\n        ")]), _vm._v(" "), _vm._c('router-link', {
    staticClass: "btn-pub btn-pub-blank fixed-width",
    attrs: {
      "to": {
        name: 'features'
      }
    }
  }, [_vm._v("Learn More")])], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 signup-form-wrap"
  }, [_vm._c('div', {
    staticClass: "signup-form"
  }, [_vm._c('p', [_vm._v("Please enter your information to sign up for CLEX")]), _vm._v(" "), _vm._l((_vm.currentUser.errors), function(msg) {
    return (_vm.currentUser.errors) ? _vm._c('div', {
      staticClass: "alert alert-contrast alert-danger alert-dismissible",
      attrs: {
        "role": "alert"
      }
    }, [_vm._c('div', {
      staticClass: "message"
    }, [_vm._v(_vm._s(msg))])]) : _vm._e()
  }), _vm._v(" "), _vm._c('form', {
    staticClass: "form-pub",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.register($event)
      }
    }
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 form-group"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.first_name),
      expression: "newUser.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "autofocus": "",
      "name": "first_name",
      "type": "text",
      "placeholder": "Your First Name",
      "autocomplete": "off",
      "required": "required"
    },
    domProps: {
      "value": _vm._s(_vm.newUser.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.first_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 form-group"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.last_name),
      expression: "newUser.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "last_name",
      "type": "text",
      "placeholder": "Your Last Name",
      "autocomplete": "off",
      "required": "required"
    },
    domProps: {
      "value": _vm._s(_vm.newUser.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.last_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._c('div', {
    staticClass: "form-group row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Your E-mail",
      "autocomplete": "off",
      "required": "required"
    },
    domProps: {
      "value": _vm._s(_vm.newUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 form-group"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.password),
      expression: "newUser.password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Password",
      "autocomplete": "off",
      "required": "required"
    },
    domProps: {
      "value": _vm._s(_vm.newUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 form-group"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.password_confirmation),
      expression: "newUser.password_confirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password_confirmation",
      "type": "password",
      "placeholder": "Re-enter Password",
      "autocomplete": "off",
      "required": "required"
    },
    domProps: {
      "value": _vm._s(_vm.newUser.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newUser.password_confirmation = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 form-group"
  }, [_vm._c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSchoolId),
      expression: "selectedSchoolId"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        _vm.selectedSchoolId = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, _vm.schoolChanged]
    }
  }, [_vm._c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("-- Select School (Optional) --")]), _vm._v(" "), _vm._l((_vm.schools), function(school) {
    return _vm._c('option', {
      domProps: {
        "value": school.id
      }
    }, [_vm._v(_vm._s(school.name))])
  })], 2)])]), _vm._v(" "), (_vm.selectedSchoolId > 0) ? _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 form-group"
  }, [_vm._c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.course_id),
      expression: "newUser.course_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.newUser.course_id = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_vm._c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("-- Select Course --")]), _vm._v(" "), _vm._l((_vm.allCourses), function(course) {
    return _vm._c('option', {
      domProps: {
        "value": course.id
      }
    }, [_vm._v(_vm._s(course.name))])
  })], 2)]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 form-group"
  }, [_vm._c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.role),
      expression: "newUser.role"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.newUser.role = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.roles), function(role) {
    return _vm._c('option', {
      domProps: {
        "value": role.id
      }
    }, [_vm._v(_vm._s(role.name))])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.currentUser.showSuccess) ? _vm._c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("We've sent you an email with a confirmation link. Please check your emails for instructions.")]) : _vm._e(), _vm._v(" "), _vm._c('div', {
    staticClass: "form-group xs-pt-10 row"
  }, [_vm._m(0), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_vm._c('router-link', {
    staticClass: "login-link",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Have an account? "), _vm._c('strong', [_vm._v("Log in")]), _vm._v(".")])], 1)])])], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_vm._c('button', {
    staticClass: "btn-pub btn-pub-primary btn-pub-borderless fixed-width xs-full-width"
  }, [_vm._v("Sign Up")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e214286!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/signup/Signup.vue
// module id = 663
// module chunks = 1